import React from "react";
import { Link } from "react-router-dom";
import BlogSidebar from "../Blog/BlogSidebar";

const BlogDetailsPost = () => {
  return (
    <>
      <div className="postbox__area pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-12">
              <div className="postbox__wrapper mr-20">
                <article className="postbox__item format-image mb-50 transition-3">
                  <div className="postbox__thumb m-img">
                    <Link to="/blog-details">
                      <img src="assets/img/blog/onfon-media-champs.jpeg" alt="" />
                    </Link>
                  </div>
                  <div className="postbox__content">
                    <div className="postbox__meta mb-25">
                      <span>
                        <Link to="/blog-details">
                          <i className="fal fa-user"></i> oliang'a M
                        </Link>
                      </span>
                      <span>
                        <i className="fal fa-calendar-day"></i> SEPTEMBER 08, 2024{" "}
                      </span>
                    </div>
                    <h3 className="postbox__title mb-25">
                    Onfon Media Group Marathon Champions
                    </h3>
                    <div className="postbox__text">
                      <p>
                        Quick summary ↬ Software development without a roadmap
                        is akin to driving off a cliff — an undertaking that
                        seriously jeopardizes your product’s life. Here’s how to
                        develop a business technology roadmap that ensures your
                        project safely reaches its final destination.
                      </p>
                      <p>
                        When people have an idea for a piece of software or an
                        app, they tend to be pretty energized about getting it
                        to market as quickly as possible. It’s exciting to
                        create an app or piece of software no one’s ever
                        imagined or built before. As software developers, we’re
                        usually right there with them.
                      </p>
                      <p>
                        At some point, though, we need to sit down with clients
                        and give them a sometimes sobering reality: software
                        development without a business technology roadmap can be
                        a lot like driving aimlessly from point A to point Z.
                        Sure, you get to discover new worlds and experience
                        unexpected adventures, but you also frequently get lost,
                        spend more money, and can lose enthusiasm for the
                        journey.
                      </p>

                      <h3 className="postbox__subtite mb-25">
                        What Is A Business Technology Roadmap? #
                      </h3>
                      <p>
                        Unlike detailed blueprints that lay out all tasks,
                        deadlines, bug reports, and more along the way,
                        technology roadmaps are high-level visual summaries
                        highlighting a company’s vision or plans.
                        <br />
                        <br />
                        In an Agile approach, a technology roadmap feeds the
                        sprint and grooming processes, providing insight into
                        how the product will travel from start to finish. It
                        makes it easier for development teams to:
                      </p>
                      <div className="row">
                        <div className="col-sm-6">
                          <p>
                            <img
                              src="assets/img/blog/onfon-champs.jpeg"
                              alt=""
                            />
                          </p>
                        </div>
                        <div className="col-sm-6">
                          <p>
                            <img
                              src="assets/img/blog/onfon-media champions.jpg"
                              alt=""
                            />
                          </p>
                        </div>
                      </div>
                      <h3 className="postbox__subtite mb-25">
                        How to become a top conference speaker?
                      </h3>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elitm sed do eiusmod tempor incididunt labore ets magna
                        aliquatenim minim veniam quis nostrud exercitation
                        ullamco laboris nisut aliquip ex ea commod Duis aute
                        irure dolorn reprehenderit voluptate velit esse
                      </p>
                    </div>
                    <div className="single-blog-cloud pt-45 pb-45 tp-brand-border">
                      <div className="row align-items-center">
                        <div className="col-12">
                          <div className="postbox__tag tagcloud">
                            <span>Tags:</span>
                            <Link to="/blog-details">Onfon Mobile</Link>
                            <Link to="/blog-details">Innovex</Link>
                            <Link to="/blog-details">Infotrace Analytics</Link>
                            <Link to="/blog-details">Mobipesa</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
                <div className="postbox__comment-form">
                  <h3 className="postbox__comment-form-title">
                    Write a comment
                  </h3>
                  <form action="#">
                    <div className="row">
                      <div className="col-xxl-6 col-xl-6 col-lg-6">
                        <div className="postbox__comment-input">
                          <input type="text" placeholder="Your Name" />
                        </div>
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-lg-6">
                        <div className="postbox__comment-input">
                          <input type="email" placeholder="Your Email" />
                        </div>
                      </div>
                      <div className="col-xxl-12">
                        <div className="postbox__comment-input">
                          <input type="text" placeholder="Website" />
                        </div>
                      </div>
                      <div className="col-xxl-12">
                        <div className="postbox__comment-input">
                          <textarea placeholder="Enter your comment ..."></textarea>
                        </div>
                      </div>
                      <div className="col-xxl-12">
                        <div className="postbox__comment-btn">
                          <button type="submit" className="tp-btn-border">
                            Post Comment
                            <span>
                              <svg
                                width="22"
                                height="8"
                                viewBox="0 0 22 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M21.3536 4.35356C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464468C17.9763 0.269205 17.6597 0.269205 17.4645 0.464468C17.2692 0.65973 17.2692 0.976312 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53554C17.6597 7.7308 17.9763 7.7308 18.1716 7.53554L21.3536 4.35356ZM-4.37114e-08 4.5L21 4.5L21 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                                  fill="currentColor"
                                ></path>
                              </svg>
                              <svg
                                width="22"
                                height="8"
                                viewBox="0 0 22 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M21.3536 4.35356C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464468C17.9763 0.269205 17.6597 0.269205 17.4645 0.464468C17.2692 0.65973 17.2692 0.976312 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53554C17.6597 7.7308 17.9763 7.7308 18.1716 7.53554L21.3536 4.35356ZM-4.37114e-08 4.5L21 4.5L21 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                                  fill="currentColor"
                                ></path>
                              </svg>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <BlogSidebar/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetailsPost;
